import api from './api';

class CampusService {
  /**
   * Get paginated list of campuses
   * @param {number} page - Page number (0-based)
   * @param {number} size - Page size
   * @param {string} search - Search query
   * @param {number} universityId - Filter by university
   * @param {string} city - Filter by city
   * @param {string} country - Filter by country
   * @returns {Promise} API response
   */
  async getCampuses(page = 0, size = 10, search = '', universityId = null, city = '', country = '') {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });
      
      if (search?.trim()) {
        params.append('search', search.trim());
      }
      
      if (universityId) {
        params.append('universityId', universityId.toString());
      }
      
      if (city?.trim()) {
        params.append('city', city.trim());
      }
      
      if (country?.trim()) {
        params.append('country', country.trim());
      }

      const response = await api.get(`/admin/campuses?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get campus by ID
   * @param {number} id - Campus ID
   * @returns {Promise} API response
   */
  async getCampus(id) {
    try {
      const response = await api.get(`/admin/campuses/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new campus
   * @param {Object} data - Campus data
   * @returns {Promise} API response
   */
async createCampus(data) {
  try {
    const response = await api.post('/admin/campuses', {
      universityId: data.universityId,
      nameEn: data.nameEn,
      nameLocal: data.nameLocal,
      countryId: data.countryId,
      cityId: data.cityId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

async updateCampus(id, data) {
  try {
    const response = await api.put(`/admin/campuses/${id}`, {
      universityId: data.universityId,
      nameEn: data.nameEn,
      nameLocal: data.nameLocal,
      countryId: data.countryId,
      cityId: data.cityId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
  /**
   * Delete campus
   * @param {number} id - Campus ID
   * @returns {Promise} API response
   */
  async deleteCampus(id) {
    try {
      const response = await api.delete(`/admin/campuses/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const campusService = new CampusService();
export default campusService;